'use client';
var classes = {"root":"m-f0824112","description":"m-57492dcc","section":"m-690090b5","label":"m-1f6ac4c4","body":"m-f07af9d2","children":"m-e17b862f","chevron":"m-1fd8a00b"};

export default classes;
//# sourceMappingURL=NavLink.module.mjs.map
